import React, { Component, Fragment } from "react";
import PageHeaderLayout from "../../layout/PageHeaderLayout";
import { Card, Button, Popconfirm, Divider, message } from "antd";
import StandardTable from "../../components/StandardTable";
import authWrapper from "../../utils/authWrapper";
import FormModal from "../../components/FormModal";
import * as api from "../../api/material";


const AddButton = authWrapper('add')(Button);
const EditFragment = authWrapper('add')(Fragment);
const DeletePopconfirm = authWrapper('add')(Popconfirm);

class Material extends Component {

    columns = [
        {
            title: 'ID',
            dataIndex: 'id'
        },
        {
            title: '名称',
            dataIndex: 'name',
        },
        {
            title: '操作',
            render: (record) => {
                return (
                    <span>
                        <EditFragment>
                            <a onClick={() => this.handleModalShow(record)}>编辑</a>
                            <Divider type={"vertical"} />
                        </EditFragment>
                        <DeletePopconfirm title={"是否确认删除"} onConfirm={() => {
                            this.handleDelete(record.id)
                        }}>
                            <a>删除</a>
                        </DeletePopconfirm>
                    </span>
                )
            }
        }
    ];

    modifyFields = [
        {
            dataIndex: 'id',
            visible: false
        },
        {
            title: '名称',
            dataIndex: 'name',
            rules: [{
                required: true, message: '请输入名称',
            }],
        }
    ];

    dataTable = undefined

    state = {
        modalVisible: false,
        modalRecord: {},
        modalSaving: false
    };

    handleModalShow = (record = {}) => {
        this.setState({
            modalVisible: true,
            modalRecord: record,
        })
    };

    handleModalOk = (fieldsValue) => {
        this.setState({
            modalSaving: true,
        });
        api.modifyMaterial({ ...fieldsValue }).then(() => {
            this.setState({
                modalSaving: false,
                modalVisible: false
            });
            this.dataTable.fetch()
        }).catch(() => {
            this.setState({
                modalSaving: false,
            });
        })
    };

    handleDelete = (materialId) => {
        api.deleteMaterial(materialId).then(() => {
            this.dataTable.fetch();
            message.success('删除成功')
        })
    };

    render() {
        return (
            <PageHeaderLayout title={'材料管理'}>
                <Card>
                    <AddButton type={"primary"} onClick={() => this.handleModalShow()}>新增</AddButton>
                    <StandardTable columns={this.columns}
                        rowKey={'id'}
                        url={'/api/material'}
                        ref={(table) => this.dataTable = table}
                    />
                </Card>
                <FormModal visible={this.state.modalVisible}
                    confirmLoading={this.state.modalSaving}
                    record={this.state.modalRecord}
                    fields={this.modifyFields}
                    onOk={this.handleModalOk}
                    onCancel={() => this.setState({ modalVisible: false })}
                />
            </PageHeaderLayout>
        )
    }


}

export default Material;
